module.exports = __webpack_public_path__ + "static/media/RaceIslandStoryBg-sm.909fdeb3.jpg";